const config = {
	auth: {
		mode: 'ws',
	},
};

export default config;
